// removed by extract-text-webpack-plugin
module.exports = {"phoneInput":"_2ELX3fai1JMRGVuKRl0myy"};


/*****************
 ** WEBPACK FOOTER
 ** ./client/form/PhoneInput.css
 ** module id = 785
 ** module chunks = 0 1
 **/